import * as angular from 'angular';
import { HttpService } from '../../api/http.service';
import { BlobService } from './blob.service';

export class AvatarService {

    public static $inject = [
        'http',
        'blobService'
    ];

    constructor(
        private http: HttpService,
        private blobService: BlobService
    ) {}

    public uploadImage(file: any, url: string = null): Promise<number> {
        if (!file) {
            throw new Error('The file is absent.');
        }

        const form = new FormData();
        form.append(
            'FileImage',
            this.blobService.dataUriToBlob(file.dataUri),
            file.name
        );
        return this.http.post<number>(
            url,
            form,
            {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            }
        );
    }
}

angular
    .module('app.common')
    .service('avatarService', AvatarService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/services/avatar.service.ts